import { IApplicationState } from 'setup/store'

export const selectJackpotList = (state: IApplicationState) => state.jackpots.data.jackpotList
